<template>
  <div class="container mx-auto w-full h-full bg-gray-200">
    <div class="overflow-hidden relative p-10 h-full wrap">
      <div class="absolute h-full border border-gray-700 border-opacity-20 border-2-2" style="left: 50%" />
      <div class="flex justify-between items-end mb-8 w-full">
        <span>
          <h3 class="mb-3 text-xl font-bold text-black">Mahasiswa</h3>
        </span>
        <span>
          <h3 class="mb-3 text-xl font-bold text-black">Admin</h3>
        </span>
      </div>

      <!-- left timeline info isEosPaymentSuccess found  -->
      <div
        class="flex flex-row-reverse justify-between items-center mb-8 w-full left-timeline">
        <div class="order-1 w-5/12" />
        <div class="order-1 py-4 px-6 w-5/12 bg-red-400 rounded-lg shadow-xl border-black border-4">
          <p class="text-sm font-medium tracking-wide leading-snug text-white text-opacity-100">
            Anda telah mendapatkan Biaya AKHIR STUDI, sehingga tidak
            dapat lagi mengajukan Beasiswa
          </p>
        </div>
      </div>

      <!-- left timeline : DITERIMA -->
      <div class="flex flex-row-reverse justify-between items-center mb-8 w-full left-timeline">
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white">
            2
          </h1>
        </div>
        <div class="order-1 py-4 px-6 w-5/12 bg-green-400 rounded-lg shadow-xl">
          <h3 class="mb-3 text-xl font-bold text-white">
            BIODATA : {{ statusList[2].name }}
          </h3>
          <p class="text-sm font-medium tracking-wide leading-snug text-white text-opacity-100">
            Berkas memenuhi syarat.
          </p>
        </div>
      </div>
      <!-- right timeline : Biodata info -->
      <div class="flex justify-between items-center mb-8 w-full right-timeline">
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white">
            1
          </h1>
        </div>
        <div
          class="order-1 py-4 px-6 w-5/12 bg-gray-400 rounded-lg shadow-xl"
          :class="statusList[1].id === statusCurrent.id &&
            'border-black border-4'
          ">
          <h3 class="mb-3 text-xl font-bold text-white">
            Biodata sudah terverifikasi
          </h3>
          <ul class="list-disc">
            <!--KTP -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP: {{ getVerifiedStatus("nik_file_verified") }}
              <i
                v-if="mahasiswa.nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.nik_file_reason
            }}</span>

            <!-- KTM -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTM:
              {{ getVerifiedStatus("student_id_file_verified") }}
              <i
                v-if="mahasiswa.student_id_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.student_id_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.student_id_file_reason
            }}</span>

            <!-- KK -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KK: {{ getVerifiedStatus("no_kk_file_verified") }}
              <i
                v-if="mahasiswa.no_kk_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.no_kk_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.no_kk_file_reason
            }}</span>

            <!-- PHOTO -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Photo: {{ getVerifiedStatus("photo_verified") }}
              <i
                v-if="mahasiswa.photo_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.photo_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.photo_reason
            }}</span>

            <!-- Buku Rekening -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Buku Rekening:
              {{ getVerifiedStatus("bank_acc_file_verified") }}
              <i
                v-if="mahasiswa.bank_acc_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.bank_acc_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.bank_acc_file_reason
            }}</span>

            <!-- KTP Ayah -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP Ayah:
              {{ getVerifiedStatus("father_nik_file_verified") }}
              <i
                v-if="mahasiswa.father_nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.father_nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.father_nik_file_reason
            }}</span>

            <!-- KTP Ibu -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP Ibu:
              {{ getVerifiedStatus("mother_nik_file_verified") }}
              <i
                v-if="mahasiswa.mother_nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.mother_nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.mother_nik_file_reasonF
            }}</span>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const VERIFIED_STATS = {
    null: 'SEDANG DIVERIFIKASI',
    0: 'DITOLAK',
    1: 'DITERIMA',
}
export default {
    props: {
        statusList: Array,
        statusCurrent: Object,
        mahasiswa: Object,
        isEosPaymentSuccess: Boolean,
    },
    computed: {
        scholarshipPeriod () {
            return this.$page.props.scholarship_period
        },
        scholarshipYear () {
            return this.$page.props.scholarship_year
        },
    },
    methods: {
        getVerifiedStatus (fieldName) {
            return VERIFIED_STATS[this.mahasiswa[fieldName]]
        },
    },
}
</script>
